<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>

  <div class="bg-white bottom-page-shadow rounded-bottom-extra mx-1">
    <div class="row ps-3">
      <div class="col pt-3 ">
        <p> <span class="fw-bold">Penyenggaraan</span> - Agih e-Borang (Ejen Cukai)</p>
      </div>
    </div>

    <div class="row pb-5 pt-5">
      <div class="col-2 mx-5">
        <input type="text" class="form-control border-0 shadow" placeholder="No. Pengenalan" [(ngModel)]="AgentIDNoInput" [ngModelOptions]="{standalone: true}" placeholder="No. Pengenalan">
      </div>
      <div class="col-8">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(AgentIDNoInput)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" (click)="Semula()" >Semula</button>
          </div>
        </div>
      </div>
    </div>

    <div class="mx-5 px-3 pb-5">
      <div>
        <p>Senarai Ejen Cukai</p>
      </div>
      <div class="example-table-container">
        <table mat-table [dataSource]="dataSource" class="w-100 shadow">
          <ng-container matColumnDef="agentname">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama Ejen Cukai</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.taxAgentName}}</td>
          </ng-container>
          <ng-container matColumnDef="agentidnno">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Pengenalan</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.icNo}}</td>
          </ng-container>
          <ng-container matColumnDef="agentapprovalno">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Kelulusan</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.licenseNo}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
            <td mat-cell *matCellDef="let res">
              <div class="btn-toolbar d-flex justify-content-center">
                <div class="me-2">
                  <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#distributeModal" (click)="DistributeView(res.taxAgentID,res.taxAgentName,res.icNo,res.licenseNo,res.status)">Agih</button>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let res;columns:displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="8">Tiada Rekod</td>
          </tr>
        </table>
        <mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event)" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10,15,20]" [length]="AgentTotalRecord">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>


<!-- Distribute Modal -->
<div class="modal fade" id="distributeModal" tabindex="-1" aria-labelledby="distributeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Agih Ejen Cukai</p>
          </div>
        </div>

        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <p class="text-muted fst-italic">Sila pilih ejen cukai dan tekan Agih</p>

            <div class="row">
              <div class="col-3">
                <p>Nama Ejen Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{CurrentAgentNameView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <p>No. Pengenalan Ejen Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{CurrentAgentIDNoView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <p>No. Kelulusan Ejen Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{CurrentAgentLicenseNoView}}</strong></p>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <p>Status Ejen Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <p><strong>{{CurrentAgentStatusView}}</strong></p>
              </div>
            </div>

            <div class="row pt-2">
              <div class="col-3">
                <p>Senarai Ejen Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-auto">
                <select class="form-select border-0 shadow" [(ngModel)]="AgentInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Ejen</option>
                  <option *ngFor="let list of AgentList" [value]="list.taxAgentID">{{list.taxAgentName}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="btn-toolbar d-flex justify-content-center pb-5 pt-5">
            <div class="me-2">
              <button type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" data-bs-dismiss="modal" (click)="DistributeSubmit(CurrentAgentIDView,AgentInput)">Agih</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



